export const version = 'kunde-v1.20.0-SNAPSHOT-6fb00a5c743cf0f6c6a22ab58a4d802d311d41f8';